import { useMemo } from 'react';

import { useStoreLocations } from 'src/providers/StoreLocationsProvider';

import { Field } from '../hook-form';

export const ALL_LOCATIONS_OPTION = { label: 'All locations', value: 'all_locations' };

export function LocationsField({
  name = 'locations',
  label = 'Location',
  helperText,
  fullWidth,
  includeAllLocations,
  includeInactiveLocations,
  disabled,
  ...rest
}: {
  name?: string;
  label?: string;
  helperText?: string;
  fullWidth?: boolean;
  includeAllLocations?: boolean;
  includeInactiveLocations?: boolean;
  disabled?: boolean;
}) {
  const { data: storeLocations, loading: storeLocationsLoading } = useStoreLocations();

  const storeLocationsOptions = useMemo(() => {
    if (storeLocationsLoading) {
      return [];
    }

    const raw = storeLocations
      .filter((location) => {
        if (includeInactiveLocations) {
          return true;
        }

        return location.status === 'ACTIVE';
      })
      .map((location) => ({
        label: location.name,
        value: location.id,
      }));

    return includeAllLocations ? [ALL_LOCATIONS_OPTION, ...raw] : raw;
  }, [storeLocations, storeLocationsLoading, includeAllLocations, includeInactiveLocations]);

  return (
    <Field.MultiSelect
      fullWidth={fullWidth}
      checkbox
      name={name}
      label={label}
      options={storeLocationsOptions}
      helperText={helperText}
      disabled={disabled}
      {...rest}
    />
  );
}
